import { PARTICIPANT_SELECT_UPDATE, PARTICIPANT_DESELECT } from "../action-types/controlPanelSelectedParticipant"

const selectedParticipantInit = {
    selectedStatus: false,
    selectedParticipantId: null,
    selectedParticipantDetail: null,
}
function controlPanelSelectedParticipantReducer(state = selectedParticipantInit, action) {
    switch (action.type) {
        case PARTICIPANT_SELECT_UPDATE: {
            return action.payload
        }
        case PARTICIPANT_DESELECT: {
            return selectedParticipantInit
        }
        default:
            return state
    }
}

export default controlPanelSelectedParticipantReducer
